import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'

const styles = stylex.create({
  root: {
    color: colors.red600,
  },
})

export function Asterisk() {
  return <span {...stylex.props(styles.root)}>*</span>
}
